import { render, staticRenderFns } from "./PriceWorkflowPromoDetails.vue?vue&type=template&id=649b02fe&"
import script from "./PriceWorkflowPromoDetails.vue?vue&type=script&lang=js&"
export * from "./PriceWorkflowPromoDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports